import ConsolidadoEmpresasPreview from "./ConsolidadoEmpresasPreview";
export default ConsolidadoEmpresasPreview;